import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useConcerns } from '../../contexts/ConcernContext';
import './SubmitConcern.css';

function SubmitConcern() {
  const navigate = useNavigate();
  const { addConcern } = useConcerns();

  const [formData, setFormData] = useState({
    title: '',
    category: 'Civil',
    priority: 'medium',
    description: ''
  });

  const [images, setImages] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    
    // Limit to 5 images
    if (files.length + images.length > 5) {
      alert('You can only upload up to 5 images');
      return;
    }

    // Add new images to existing ones
    setImages([...images, ...files]);

    // Create preview URLs for new images
    const newPreviews = files.map(file => URL.createObjectURL(file));
    setImagePreviews([...imagePreviews, ...newPreviews]);
  };

  const removeImage = (index) => {
    // Remove image from array
    const newImages = images.filter((_, i) => i !== index);
    setImages(newImages);

    // Remove preview and revoke URL to free memory
    URL.revokeObjectURL(imagePreviews[index]);
    const newPreviews = imagePreviews.filter((_, i) => i !== index);
    setImagePreviews(newPreviews);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Add concern with images
    const concernWithImages = {
      ...formData,
      images: images
    };
    
    const result = await addConcern(concernWithImages);
    
    if (result.success) {
      console.log('Form submitted with data:', concernWithImages);
      alert('Concern submitted successfully!');
      navigate('/my-concerns');
    } else {
      alert(`Failed to submit concern: ${result.error}`);
    }
  };

  const handleCancel = () => {
    // Clean up preview URLs
    imagePreviews.forEach(url => URL.revokeObjectURL(url));
    navigate('/client-dashboard');
  };

  return (
    <div className="submit-concern-page">
      <nav className="dashboard-nav">
        <div className="container nav-content">
          <h2 className="logo">EngineeringCubes</h2>
          <button onClick={() => navigate('/client-dashboard')} className="btn btn-secondary">
            Back to Dashboard
          </button>
        </div>
      </nav>

      <div className="page-content">
        <div className="container">
          <div className="form-container">
            <h1 className="page-title">Submit New Concern</h1>
            <p className="page-subtitle">Describe your project concern and we'll review it promptly</p>

            <form onSubmit={handleSubmit} className="concern-form">
              <div className="form-group">
                <label htmlFor="title">Concern Title *</label>
                <input
                  type="text"
                  id="title"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  placeholder="Brief title of your concern"
                  required
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="category">Category *</label>
                  <select
                    id="category"
                    name="category"
                    value={formData.category}
                    onChange={handleChange}
                    required
                  >
                    <option value="Civil">Civil Work</option>
                    <option value="Electrical">Electrical Work</option>
                    <option value="Plumbing">Plumbing Work</option>
                    <option value="Water Proofing">Water Proofing</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="priority">Priority *</label>
                  <select
                    id="priority"
                    name="priority"
                    value={formData.priority}
                    onChange={handleChange}
                    required
                  >
                    <option value="low">Low</option>
                    <option value="medium">Medium</option>
                    <option value="high">High</option>
                    <option value="urgent">Urgent</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="description">Description *</label>
                <textarea
                  id="description"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Provide detailed description of the concern..."
                  rows="6"
                  required
                />
              </div>

              {/* Image Upload Section */}
              <div className="form-group">
                <label htmlFor="images">Upload Images (Optional)</label>
                <p className="field-hint">Upload up to 5 images to help describe the concern</p>
                <input
                  type="file"
                  id="images"
                  name="images"
                  accept="image/*"
                  multiple
                  onChange={handleImageChange}
                  className="file-input"
                />
                
                {/* Image Previews */}
                {imagePreviews.length > 0 && (
                  <div className="image-previews">
                    {imagePreviews.map((preview, index) => (
                      <div key={index} className="image-preview-item">
                        <img src={preview} alt={`Preview ${index + 1}`} />
                        <button
                          type="button"
                          onClick={() => removeImage(index)}
                          className="remove-image-btn"
                          aria-label="Remove image"
                        >
                          ×
                        </button>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="form-actions">
                <button type="button" onClick={handleCancel} className="btn btn-secondary">
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  Submit Concern
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubmitConcern;